import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientPrograms.scss';export default {
  "ClientPrograms": "_ClientPrograms_kyl92_1",
  "text": "_text_kyl92_1"
};